import template from "./create-proposal.html";

const CreateProposalComponent = {
  bindings: {
    organization: "<",
  },

  template: template,

  controller: class CreateProposalController {
    /* @ngInject */
    constructor(
      $rootScope,
      $state,
      $scope,
      $location,
      SmartVault,
      SecurityManager
    ) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$location = $location;
      this.SmartVault = SmartVault;
      this.SecurityManager = SecurityManager;
    }

    async $onInit() {
      const { cid, fid } = this.$location.search();
      try {
        const { organization, client } = await this.SmartVault.createProposal(
          fid,
          cid
        );
        if (client.foldersPath) {
          this.$state.go("app.dashboard", {
            organization: organization.slug,
            cid: cid,
          });
        } else {
          this.error = true;
        }
      } catch (e) {
        this.error = true;
      }
    }
  },
};

export default CreateProposalComponent;
